import { usePermissionStateStore } from "@/store/PermissionState"
import { formatPhoneNumber, maskEmail, maskPhone } from "@/utils/mask"
import { isProbablyAPhoneNumber, keepOnlyDigits } from "@/utils/phone"

const useContactDisplay = () => {
	const { checkPermission } = usePermissionStateStore()

	const canViewSensitiveData = checkPermission("contact", "view-sensitive-data")

	const getDisplayPhoneNumber = (phone?: string): string | undefined =>
		formatPhoneNumber(canViewSensitiveData ? phone : maskPhone(phone ?? ""))

	const getDisplayEmail = (email?: string): string =>
		canViewSensitiveData ? (email ?? "") : maskEmail(email ?? "")

	const getDisplayName = (nickname?: string, phone?: string): string | undefined => {
		const nicknameMatchesContactPhone = Boolean(phone) && keepOnlyDigits(nickname ?? "") === keepOnlyDigits(phone ?? "")
		const nicknameLooksLikeAPhoneNumber = isProbablyAPhoneNumber(nickname)

		if (nicknameMatchesContactPhone || nicknameLooksLikeAPhoneNumber) {
			return getDisplayPhoneNumber(nickname)
		}

		return nickname
	}

	return { getDisplayName, getDisplayPhoneNumber, getDisplayEmail, canViewSensitiveData }
}

export default useContactDisplay
